import { TextFieldModule } from '@angular/cdk/text-field';
import {
	ChangeDetectionStrategy,
	Component,
	input,
	OnChanges,
	output,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormFieldLabelComponent } from '@app/shared/ui-components/form-field-label/form-field-label.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'entity-description',
	imports: [
		MatFormFieldModule,
		FormFieldLabelComponent,
		NgxTolgeeModule,
		ReactiveFormsModule,
		FormsModule,
		MatInputModule,
		TextFieldModule,
	],
	templateUrl: './entity-description.component.html',
	styleUrl: './entity-description.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityDescriptionComponent implements OnChanges {
	tabs = input<number>(1);
	selectedDescription = input<string>();
	canEditTemplate = input<boolean>(true);
	descriptionChanged = output<string>();

	descriptionForm = new FormControl();

	onBlur() {
		if (this.descriptionForm.valid) {
			this.descriptionChanged.emit(this.descriptionForm.value);
		}
	}

	ngOnChanges(): void {
		this.descriptionForm.setValue(this.selectedDescription());
		if (!this.canEditTemplate()) {
			this.descriptionForm.disable();
			return;
		}
		this.descriptionForm.enable();
	}
}
